import { Routes } from '@angular/router';
import { slugResolver } from './resolvers/slug.resolver';

export const liveRoutes: Routes = [
  {
    path: ':slug',
    resolve: { orgData: slugResolver },
    loadComponent: () => import('./pages/Overview/Overview.component').then((m) => m.OverviewComponent),
  },
];
